import React from 'react';
import { useAppStore } from '../../../stores/useAppStore';
import './styles.scss';
import SidebarFooter from '../footer';
import { ConfluenceIcon, JiraIcon, TeamsIcon, ChatIcon, HubIcon, StudioIcon } from '@atlaskit/logo';
import { LinkMenuItem } from '@atlaskit/navigation-system/side-nav-items/link-menu-item';
import { useLocation } from 'react-router-dom';

export default function Sidebar() {
  const currentUser = useAppStore(state => state.currentUser);
  const location = useLocation();
  const orgId = currentUser?.orgId || null;

  const currentPath = location.pathname;

  // Roles are additive — a user with both `isAdmin` and `isManager` sees
  // every page they have rights to. A manager who isn't an admin doesn't
  // see Organization/Integrations; an admin who isn't a manager doesn't
  // see Dashboard/1:1s/etc.
  let NAV = [];
  if (currentUser?.isManager) {
    NAV.push(
      {
        to: '/app/dashboards',
        label: 'Dashboard',
        icon: <JiraIcon appearance='inverse' shouldUseNewLogoDesign size="xsmall" />,
      },
      {
        to: '/app/one-on-ones',
        label: '1:1s',
        icon: <TeamsIcon appearance='inverse' shouldUseNewLogoDesign size="xsmall" />,
      },
      {
        to: '/app/goals',
        label: 'Goals',
        icon: <ConfluenceIcon appearance='inverse' shouldUseNewLogoDesign size="xsmall" />,
      },
      {
        to: '/app/feedback',
        label: 'Feedbacks',
        icon: <ChatIcon appearance='inverse' shouldUseNewLogoDesign size="xsmall" />,
      },
      {
        to: '/app/decisions',
        label: 'Agreements',
        icon: <TeamsIcon appearance='inverse' shouldUseNewLogoDesign size="xsmall" />,
      },
    );
  }
  if (currentUser?.isAdmin) {
    if (orgId) {
      NAV.push({
        to: `/app/admin`,
        label: 'Organization',
        icon: <HubIcon appearance='inverse' shouldUseNewLogoDesign size="xsmall" />,
      });
    }
    NAV.push({
      to: '/app/integrations',
      label: 'Integrations',
      icon: <StudioIcon appearance='inverse' shouldUseNewLogoDesign label="" size="xsmall" />,
    });
  }

  return (
    <aside className="em-sidebar">
      <>
        {NAV.map(item => (
          <div style={{ marginBottom: 8 }}>
            <LinkMenuItem
              key={item.to}
              href={item.to}
              elemBefore={item.icon}
              isSelected={currentPath === item.to}
            >
              {item.label}
            </LinkMenuItem>
          </div>
        ))}
      </>
      <SidebarFooter />
    </aside>
  );
}
